
type LinearUnits = {
  kmph: string | undefined;
  mph: string | undefined;
  mps: string | undefined;
  inps: string | undefined;
  ftps: string | undefined;
}

type RadiusUnits = {
  mm: string | undefined;
  in: string | undefined;
}

type RotationUnits = {
  rpm: string | undefined;
  radps: string | undefined;
}


export type SpeedConversionState = {
  linear: LinearUnits;
  radius: RadiusUnits;
  rotation: RotationUnits;
};


// Reducer
type ConversionCategory = keyof Pick<
  SpeedConversionState,
  'linear' | 'radius' | 'rotation'
>;

type UpdateUnitAction = {
  type: 'update_unit';
  payload: {
    category: ConversionCategory;
    updatedUnits: Record<string, string>; // contains both the input and converted unit(s)
  };
};

type ResetCategoryAction = {
  type: 'reset_category';
  payload: {
    category: ConversionCategory;
  };
};

type ConversionAction =
  | UpdateUnitAction
  | ResetCategoryAction;


export const speedConversionInitialState: SpeedConversionState = {
  linear: { kmph: undefined, mph: undefined, mps: undefined, inps: undefined, ftps: undefined },
  radius: { mm: undefined, in: undefined },
  rotation: { rpm: undefined, radps: undefined },
};


export const speedConversionReducer = (
  state: SpeedConversionState,
  action: ConversionAction
): SpeedConversionState => {
  switch (action.type) {
    case 'update_unit': {
      const { category, updatedUnits } = action.payload;

      return {
        ...state,
        [category]: {
          ...state[category],
          ...updatedUnits,
        },
      };
    }

    case 'reset_category': {
      const { category } = action.payload;
      const resetCategoryState = Object.keys(state[category]).reduce((acc, key) => {
        acc[key] = undefined;
        return acc;
      }, {} as Record<string, string | undefined>);

      return {
        ...state,
        [category]: resetCategoryState,
      };
    }

    default:
      return state;
  }
};
